import { AppConfig } from '../../../app-config'
import { triggerSimpleAjax } from '../../../utils/http-helper'
const API_URL = AppConfig.api_url

/**
 * This method handles the signup API req and basic success/error responses
 * @param {object} param
 *  -- param structure: {
 *  {string} signupType
 *  {object} reqObj
 *  {string} campaignItineraryId
 *  {function} successSubmitCallback - used to set submitting status in context
 *  {funciton} failureSubmitCallback - used to set errors state of signup context & submit status
 * }
 */
export const triggerForgotPassword = ({
	reqObj = {},
	successSubmitCallback,
	failureSubmitCallback,
}) => {
	let url = `${API_URL}user/forgetpassword`
	return new Promise((resolve, reject) => {
		triggerSimpleAjax({
			url,
			method: 'POST',
			body: reqObj,
			onSuccess: response => {
				if (response && response.status === 'SUCCESS') {
					if (response.data && response.data.status === 'SENT') {
						successSubmitCallback(response)
						resolve()
					} else {
						failureSubmitCallback({
							message: response.data.statusMessage,
							status: response.data.status,
						})
						reject()
					}
				} else {
					failureSubmitCallback({
						message: response?.data?.statusMessage,
						status: response?.data?.status,
					})
					reject()
				}
			},
			onFailure: error => {
				failureSubmitCallback?.({ error })
				reject(error)
			},
		})
	})
}
